export const filterDays = [
  {
    textFr: "L",
    textEn: "M",
    value: 1,
  },
  {
    textFr: "M",
    textEn: "T",
    value: 2,
  },
  {
    textFr: "M",
    textEn: "W",
    value: 3,
  },
  {
    textFr: "J",
    textEn: "T",
    value: 4,
  },
  {
    textFr: "V",
    textEn: "F",
    value: 5,
  },
  {
    textFr: "S",
    textEn: "S",
    value: 6,
  },
  {
    textFr: "D",
    textEn: "S",
    value: 7,
  },
];
